<template>
  <component is="style" type="text/css">
    {{ state.css }}
  </component>
  <div v-if="state.text" class="lf-text" :style="state.elementStyling?.wrapper">
    <div class="lf-text__content">
      <RichTextRenderer
        :style="state?.elementStyling?.inline"
        :html="state.text"
        :extra-replacement-tags="model.column.replacementTags"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue';
import { AddonLfTextModel } from '@/components/addons/lf-text/Model';
import RichTextRenderer from '@/components/RichTextRenderer.vue';
import useFontObserver from '@/hooks/useFontObserver';

export default defineComponent({
  name: 'AddonLfText',
  components: { RichTextRenderer },
  props: {
    model: {
      type: Object as PropType<AddonLfTextModel>,
      required: true
    }
  },
  setup(props) {
    const state = (props.model as AddonLfTextModel).state;

    let readyPromiseResolve: (() => void) | undefined;
    const readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });

    onMounted(async () => {
      const { isFontLoaded } = useFontObserver();

      if (state.settings?.layout?.typography?.fontFamily) {
        await isFontLoaded(state.settings.layout.typography.fontFamily);
      }
      if (readyPromiseResolve) {
        readyPromiseResolve();
      }
    });
    return {
      state,
      onBeforeEnter: async () => {
        await readyPromise;
      }
    };
  }
});
</script>

<style lang="scss">
.lf-text {
  width: 100%;

  img {
    display: inline-block;
  }

  ul {
    list-style-position: outside;
    margin-left: 3rem;
    margin-bottom: 2rem;
  }
}
</style>
